/**
 * <ParentRequestRow> — une ligne de « Demandes en cours » (molecule) : la demande dite de haut — ce qu'elle est,
 * ce qui change, où elle en est —, et toute la ligne qui en ouvre le détail. Une ligne de `<CardList>` : elle ne
 * dessine pas sa surface.
 */
import React from "react"
import { Pressable } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Icon } from "../../atoms/icons/Icon"
import { IconBubble } from "../../atoms/icons/IconBubble"
import { Text } from "../../atoms/typography/Text"
import { CardListRow } from "../CardList"
import { type UIParentRequest } from "../../../ports/primary/ui/types"

export type ParentRequestRowProps = {
    request: UIParentRequest
    /** Ouvre le détail. Absent : la ligne se lit sans geste. */
    onPress?: (request: UIParentRequest) => void
    testID?: string
}

export function ParentRequestRow(props: ParentRequestRowProps) {
    const { request, onPress, testID } = props

    return (
        <Pressable
            testID={testID}
            onPress={onPress != null ? () => onPress(request) : undefined}
            disabled={onPress == null}
            accessibilityRole="button"
            accessibilityLabel={`${request.title}, ${request.detail}. ${request.statusLine}`}
            style={({ pressed }) => (pressed && onPress != null ? styles.pressed : undefined)}
        >
            <CardListRow>
                <Row gap="3" align="center">
                    <IconBubble iconName="hourglass-half" />
                    <Stack gap="1" style={styles.text}>
                        <Text size="text-md" weight="bold">
                            {request.title}
                        </Text>
                        {request.detail !== "" && <Text size="text-sm">{request.detail}</Text>}
                        <Text size="text-sm" color="text-muted">
                            {request.statusLine}
                        </Text>
                    </Stack>
                    {onPress != null && <Icon name="chevron-right" size={20} color="text-muted" />}
                </Row>
            </CardListRow>
        </Pressable>
    )
}

const styles = StyleSheet.create(() => ({
    text: { flex: 1, flexShrink: 1 },
    pressed: { opacity: 0.8 },
}))
